// extracted by mini-css-extract-plugin
export default {"error-message":"ErrorMessage_error-message__fRmDF","fade-out":"ErrorMessage_fade-out__PGwBL","copy-paste":"ErrorMessage_copy-paste__cg8VM"};